module.exports = __webpack_public_path__ + "static/passenger-mobile-ticket-seated-coach-5e64169a266503ad296bad232a92db3d.jpg";